<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                        <strong>Tìm kiếm, tra cứu thông tin nhật ký đồng bộ dữ liệu sang QLTSC</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Đơn vị quản lý:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.unitId" ref="unitTree" allowTraversal :traversalOption.sync="searchForm.unitTraversalOption"></unit-tree>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="6">
                                <b-form-group label="Ngày đồng bộ từ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker id="input-startdate" v-model="searchForm.startDate" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                                <b-form-group label="Loại dữ liệu đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input id="input-tablename" v-model="searchForm.tableName"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col lg="6">
                                <b-form-group label="Đến:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker id="input-enddate" v-model="searchForm.endDate" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>                                
                                <b-form-group label="Trạng thái:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="searchForm.isPending" :options="pendingStatus"
                                              style="width:100%"
                                              allowClear="true"
                                              placeholder="--- Tất cả ---"></select2>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!--<b-row>
                            <b-col lg="6">
                                <b-form-group label="Loại đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="searchForm.actionType" :options="listActionTypes"
                                             style="width:100%"
                                             allowClear="true"
                                             placeholder="--- Tất cả ---"></select2>
                                </b-form-group>
                            </b-col>
                            <b-col lg="6">
                            </b-col>
                        </b-row>-->
                        <b-row class="text-center">
                            <b-col sm="12">
                                <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="logGroupGridOptions"
                            :showActions="true"
                            dataUrl="logging/services-log-groups"
                            gridName="Danh sách nhật ký đồng bộ dữ liệu sang QLTSC"
                            ref="serviceLogGroupTable">
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button size="sm" @click="row.toggleDetails" class="mr-2" variant="info">
                                    <span v-if="!row.detailsShowing" title="Xem chi tiết">Xem</span>
                                    <span v-else title="Ẩn chi tiết">Ẩn</span>
                                </b-button>
                                <!--<b-button size="sm" @click="resend(row.item)" variant="primary" v-if="row.item.syncStatus == 0 || row.item.syncStatus == 2">Đồng bộ {{ row.item.syncStatus == 2 ? 'lại' : '' }}</b-button>
                                <b-button size="sm" @click="cancel(row.item)" variant="danger" v-if="row.item.syncStatus == 0 || row.item.syncStatus == 2">Hủy</b-button>-->
                            </b-button-group>
                        </template>
                        <template v-slot:cell(syncDate)="row">
                            {{ row.value | formatTime }}
                        </template>
                        <template v-slot:cell(totalPending)="row">
                            <span :class="row.value == 0 ? 'text-success' : 'text-danger'">{{ row.value > 0 ? 'Chờ đồng bộ' : 'Đã đồng bộ' }}</span>
                        </template>
                        <template v-slot:cell(tableName)="row">
                            {{ getTableDisplayName(row.value) }}
                        </template>
                        <template v-slot:row-details="row">
                            <b-card>
                                <b-grid :searchForm="{ tableName: row.item.tableName, recordId: row.item.recordId }"
                                        :gridOptions="logGridOptions"
                                        :showActions="true"
                                        dataUrl="logging/services-logs">
                                    <template v-slot:cell(_actions)="row">
                                        <b-button-group>
                                            <b-button size="sm" @click="row.toggleDetails" class="mr-2" variant="info">
                                                <span v-if="!row.detailsShowing" title="Xem chi tiết">Xem</span>
                                                <span v-else title="Ẩn chi tiết">Ẩn</span>
                                            </b-button>
                                            <b-button size="sm" @click="resend(row.item)" variant="primary" v-if="row.item.syncStatus == 0 || row.item.syncStatus == 2">Đồng bộ {{ row.item.syncStatus == 2 ? 'lại' : '' }}</b-button>
                                            <b-button size="sm" @click="cancel(row.item)" variant="danger" v-if="row.item.syncStatus == 0 || row.item.syncStatus == 2">Hủy</b-button>
                                        </b-button-group>
                                    </template>
                                    <template v-slot:cell(syncDate)="row">
                                        {{ row.value | formatTime }}
                                    </template>
                                    <template v-slot:cell(elapsedTime)="row">
                                        {{ row.value | formatNumber }} ms
                                    </template>
                                    <template v-slot:cell(syncStatus)="row">
                                        <span :class="row.value == 1 ? 'text-success' : ( row.value == 2 ? 'text-danger' : '')">{{ (listStatuses.find(x => x.id == row.value) || {}).text }}</span>
                                    </template>
                                    <template v-slot:cell(actionType)="row">
                                        <span>{{ (listActionTypes.find(x => x.id == row.value) || {}).text }}</span>
                                    </template>
                                    <template v-slot:cell(tableName)="row">
                                        {{ getTableDisplayName(row.value) }}
                                    </template>
                                    <template v-slot:row-details="row">
                                        <b-card>
                                            <ul>
                                                <li>
                                                    Thông tin chi tiết:
                                                    <ul style="max-width: 1200px">
                                                        <li>Mã đồng bộ (UUID): {{ row.item.uuid}}</li>
                                                        <!--<li>Tên Job đồng bộ: {{ row.item.jobName}}</li>-->
                                                        <!--<li>Display name: {{ row.item.jobDisplayName}}</li>-->
                                                        <li>Dữ liệu đồng bộ: {{ getTableDisplayName(row.item.tableName)}}</li>
                                                        <li>Đơn vị quản lý: {{ unitName }}</li>
                                                        <li>Ngày đồng bộ: {{ row.item.syncDate | formatTime }}</li>
                                                        <li>Loại đồng bộ: {{ (listActionTypes.find(x => x.id == row.item.actionType) || {}).text }}</li>
                                                        <li>Thời gian thực hiện: {{ row.item.elapsedTime | formatNumber }} ms</li>
                                                        <li>URL: {{ (row.item.baseServiceUrl) + (row.item.servicePathUrl ? row.item.servicePathUrl : '')}}</li>
                                                        <li>Access Token: {{ row.item.accessToken }}</li>
                                                        <li>Repuest Body: {{ row.item.requestBody }}</li>
                                                        <li>Trạng thái: {{ (listStatuses.find(x => x.id == row.item.syncStatus == 1) || {}).text }}</li>
                                                        <li>Dữ liệu trả về: {{ row.item.errorMessage }}</li>
                                                    </ul>
                                                </li>
                                            </ul>
                                            <b-button size="sm" @click="row.toggleDetails">Ẩn chi tiết</b-button>
                                        </b-card>
                                    </template>
                                </b-grid>
                            </b-card>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ListServiceSyncResponseLog',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    tablename: null,
                    startDate: null,
                    endDate: new Date().formatDate(),
                    status: null,
                    unitId: this.getUnitTreeIdCache(1),
                    unitTraversalOption: this.getUnitTreeTraversalOptionCache(),
                },
                logGroupGridOptions: {
                    fields: [
                        { key: 'tableName', label: 'Dữ liệu đồng bộ', sortable: true },
                        { key: 'unitName', label: 'Đơn vị quản lý', sortable: true },
                        { key: 'syncDate', label: 'Ngày đồng bộ', sortable: true },
                        { key: 'totalPending', label: 'Trạng thái', sortable: true },
                    ],
                    sortBy: 'syncDate',
                    sortDesc: true
                },
                logGridOptions: {
                    fields: [
                        { key: 'uuid', label: 'Mã đồng bộ (UUID)', sortable: true },
                        //{ key: 'jobName', label: 'Tên Job', sortable: true },
                        { key: 'tableName', label: 'Dữ liệu đồng bộ', sortable: true },
                        { key: 'unitName', label: 'Đơn vị quản lý', sortable: true },
                        { key: 'syncDate', label: 'Ngày đồng bộ', sortable: true },
                        { key: 'actionType', label: 'Loại đồng bộ', sortable: true },
                        { key: 'syncStatus', label: 'Trạng thái', sortable: true },
                        { key: 'elapsedTime', label: 'Thời gian xử lý', sortable: true },
                        //{ key: 'baseServiceUrl', label: 'Dịch vụ cơ sở', sortable: true },
                        //{ key: 'servicePathUrl', label: 'Đường dẫn dịch vụ', sortable: true },
                        //{ key: 'accessToken', label: 'Mã xác thực', sortable: false }
                        //{ key: 'errorMessage', label: 'Thông tin lỗi', sortable: true },
                    ],
                    sortBy: 'syncDate',
                    sortDesc: true
                },
                listStatuses: [
                    { id: 0, text: 'Chờ đồng bộ' },
                    { id: 1, text: 'Đã đồng bộ' },
                    { id: 2, text: 'Đồng bộ lỗi' },
                    { id: 3, text: 'Đã hủy' },
                    { id: 4, text: 'Đang xử lý' }
                ],
                pendingStatus: [
                    { id: false, text: 'Đã đồng bộ' },
                    { id: true, text: 'Chờ đồng bộ' }
                ],
                listActionTypes: [
                    { id: 1, text: 'Thêm mới' },
                    { id: 2, text: 'Cập nhật' },
                    { id: 3, text: 'Xóa' }
                ]
            }
        },
        computed: {
            //...mapState({
            //    listStatuses: (state) => state.common.listStatuses,
            //})
        },
        created() {
        },
        methods: {
            search() {
                this.$refs.serviceLogGroupTable.refresh();
            },
            getTableDisplayName(tableName) {
                switch (tableName) {
                    case 'TSC.USERS': return 'Người dùng';
                    case 'TSC.ASSET_AMORTIZATIONS': return 'Hao mòn tài sản';
                    case 'TSC.ASSET_DEPRECIATION': return 'Khấu hao tài sản';
                    case 'TSC.ASSET_EXPLOITATION_DECISIONS': return 'Quyết định khai thác tài sản';
                    case 'TSC.ASSET_EXPLOITATION_DOCUMENTS': return 'Chứng từ khai thác tài sản';
                    case 'TSC.ASSET_EXPLOITATIONS': return 'Khai thác tài sản';
                    case 'TSC.ASSET_MUTATIONS': return 'Biến động tài sản';
                    case 'TSC.ASSET_SOURCES': return 'DM nguồn gốc tài sản';
                    case 'TSC.ASSET_TYPE_TREES': return 'DM cây phân loại tài sản';
                    case 'TSC.ASSET_TYPES': return 'DM nhóm tài sản';
                    case 'TSC.ASSET_USAGE_PURPOSES': return 'DM mục đích sử dụng';
                    case 'TSC.ASSET_USAGE_STATES': return 'DM hiện trạng sử dụng';
                    case 'TSC.REGIONS': return 'DM địa bàn';
                    case 'TSC.COUNTRIES': return 'DM quốc gia';
                    case 'TSC.ASSET_HANDLING_FORMS': return 'DM hình thức xử lý';
                    case 'TSC.ASSET_HANDLING_METHODS': return 'DM phương thức xử lý';
                    case 'TSC.UNIT_TYPES': return 'DM loại đơn vị';
                    case 'TSC.UNITS': return 'DM đơn vị';
                    case 'TSC.DEPARTMENTS': return 'DM bộ phận sử dụng';
                    case 'TSC.PROJECTS': return 'DM dự án';
                    default: return tableName;
                }
            },
            resend(item) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn đồng bộ thông tin này?')) {
                    this.$services.post(`data/sync-data/${item.id}`).done(() => {
                        vm.$toastr.s('Đồng bộ thành công');
                        vm.search();
                    })
                }
            },
            cancel(item) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn hủy đồng bộ thông tin này?')) {
                    this.$services.delete(`data/sync-data/${item.id}`).done(() => {
                        vm.$toastr.s('Hủy đồng bộ thành công');
                        vm.search();
                    })
                }
            }
        }
    }
</script>